import { render, staticRenderFns } from "./ChallengeHeaderDesk.vue?vue&type=template&id=912db312&"
import script from "./ChallengeHeaderDesk.vue?vue&type=script&lang=js&"
export * from "./ChallengeHeaderDesk.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeHeaderDesk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports